var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10080",
    "data-name": "Group 10080",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.23,
    height: 9.426,
    viewBox: "0 0 13.23 9.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3378",
    "data-name": "Rectangle 3378",
    width: 13.23,
    height: 9.426,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10079",
    "data-name": "Group 10079",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27159",
    "data-name": "Path 27159",
    d: "M11.351,9.426H1.879A1.881,1.881,0,0,1,0,7.546V1.879A1.881,1.881,0,0,1,1.879,0h9.472A1.881,1.881,0,0,1,13.23,1.879V7.546a1.881,1.881,0,0,1-1.879,1.879M1.879.663A1.215,1.215,0,0,0,.663,1.879V7.546A1.215,1.215,0,0,0,1.879,8.762h9.472a1.215,1.215,0,0,0,1.216-1.216V1.879A1.215,1.215,0,0,0,11.351.663Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27160",
    "data-name": "Path 27160",
    d: "M7.039,8.86a1.878,1.878,0,0,1-1.134-.378L.743,4.577a.331.331,0,1,1,.4-.529L6.306,7.958a1.226,1.226,0,0,0,1.467,0l5.163-3.909a.331.331,0,1,1,.4.529l-5.162,3.9a1.878,1.878,0,0,1-1.134.378",
    transform: "translate(-0.424 -2.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27161",
    "data-name": "Path 27161",
    d: "M.775,18.575A.331.331,0,0,1,.553,18L4.62,14.368a.332.332,0,0,1,.442.5L1,18.491a.321.321,0,0,1-.221.084m12.3,0a.321.321,0,0,1-.221-.084L8.791,14.863a.332.332,0,0,1,.442-.5L13.3,18a.329.329,0,0,1,.09.366.334.334,0,0,1-.311.213Z",
    transform: "translate(-0.312 -10.073)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.e2541e30d4ccf1a5d6f8029d2101489c.svg";
export { ForwardRef as ReactComponent };